export default __webpack_public_path__ + "static/media/icon_notes.8ba27214.svg";